import { FabricObject } from 'fabric';

import { Coords, SpreadGroundImage } from 'editor/src/store/design/types';

import CustomFabricImage from 'editor/src/fabric/CustomFabricImage';

function createSpreadMaskClipPath(
  maskImageData: SpreadGroundImage,
  maskImage: HTMLImageElement,
  spreadWidthPx: number,
  spreadHeightPx: number,
  spreadCoords: Coords,
) {
  const scaleX = spreadWidthPx / maskImageData.width;
  const scaleY = spreadHeightPx / maskImageData.height;

  return new CustomFabricImage(maskImage, {
    getCrossOrigin: () => 'anonymous',
    objectCaching: false,
    absolutePositioned: true,
    angle: 0,
    // Match SpreadGroundImageElement exactly: the source image is placed with
    // the spread label-rectangle scale, without a natural-size correction.
    scaleX,
    scaleY,
    left: spreadCoords.left - maskImageData.left * scaleX,
    top: spreadCoords.top - maskImageData.top * scaleY,
    selectable: false,
    evented: false,
  }) as FabricObject;
}

export default createSpreadMaskClipPath;
